import React, { FC } from 'react'
import Carousel from 'react-multi-carousel'

import space_styles from './SpacePhotoCarousel.module.scss'

type Props = {
  photos: { url?: string }[]
}

const CustomDot = ({ onClick, active, index }: any) => {
  return (
    <li
      onClick={() => onClick()}
      className={`${space_styles.dot} ${active ? space_styles.active : space_styles.inactive}`}
      key={index}
    />
  )
}

/** スペース写真のカルーセル。写真がない場合はデフォルト画像を表示する。 */
export const SpacePhotoCarousel: FC<Props> = ({ photos }) => {
  return (
    <Carousel
      ssr
      draggable
      swipeable
      responsive={{
        desktop: {
          breakpoint: {
            max: 3000,
            min: 300,
          },
          items: 1,
        },
      }}
      className={space_styles.spaceImageItems}
      customLeftArrow={<div className={space_styles.prev} />}
      customRightArrow={<div className={space_styles.next} />}
      showDots
      dotListClass={space_styles.dotList}
      customDot={<CustomDot />}
    >
      {photos.length ? (
        photos.map((photo, index) => (
          <img
            src={photo.url || '/location_popular_area_default.webp'}
            alt={`Space photo ${index + 1}`}
            key={index}
            className={space_styles.spaceImage}
          />
        ))
      ) : (
        <img src="/location_popular_area_default.webp" className={space_styles.spaceImage} alt="" />
      )}
    </Carousel>
  )
}
